import type { FaireProductEntity } from "../../entity_types/product";

export const p_jdh933mkzs: FaireProductEntity = {
  token: "p_jdh933mkzs",
  type: "product",
  name: "Lavender Sleep Herbal Tea \u2013 2 oz Loose Leaf",
  brandName: "123 Farm",
  imageUrl:
    "https://cdn.faire.com/fastly/3ae18e9860d11ce982f32c1dc5c3f80d943eeba675e424441ba4f2aa47899006.png",
  priceDollars: 8.4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a4993b4dbfb17de94b2291d13c4bd5efcd68f0f113ab6456602b31be53db0414.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
